export const types = {
    CONNECT: 'CONNECT',
    CONNECT_SUCCESS: 'CONNECT_SUCCESS',
    CONNECT_FAIL: 'CONNECT_FAIL',

    DISCONNECT: 'DISCONNECT',
    DISCONNECT_SUCCESS: 'DISCONNECT_SUCCESS',
    DISCONNECT_FAIL: 'DISCONNECT_FAIL',

    RETRIEVE_MESSAGES: 'RETRIEVE_MESSAGES',
    RETRIEVE_ROOMS: 'RETRIEVE_ROOMS',

    GET_MY_ROOMS: 'GET_MY_ROOMS',
    GET_MY_ROOMS_SUCCESS: 'GET_MY_ROOMS_SUCCESS',
    GET_MY_ROOMS_FAIL: 'GET_MY_ROOMS_FAIL',

    USER_TYPING: 'USER_TYPING',
    USER_STOP_TYPING: 'USER_STOP_TYPING',

    TYPING_STATUS: 'TYPING_STATUS',

    USER_HAS_READ: 'USER_HAS_READ',

    JOIN_ALL_CHAT_ROOMS: 'JOIN_ALL_CHAT_ROOMS',

    SET_ONLINE_STATUS: 'SET_ONLINE_STATUS',

    SET_ONLINE_USERS: 'SET_ONLINE_USERS',

    SET_OFFLINE_USER: 'SET_OFFLINE_USER',

    SET_ROOM_MESSAGES: 'SET_ROOM_MESSAGES',
    SET_ROOM_MESSAGES_SUCCESS: 'SET_ROOM_MESSAGES_SUCCESS',
    SET_ROOM_MESSAGES_FAIL: 'SET_ROOM_MESSAGES_FAIL',
};

export interface ILiveInitialState {
    connected: boolean;
    socket: any;
}
